export default "__VITE_ASSET__gdDHslZg__"